<button
    ds-button
    msThemedButton
    kind="tertiary"
    variant="outline"
    size="small"
    class="edit-pre-created-bab-button"
    [themeKind]="buttonThemeKind"
    (click)="clickHandler($event)">
    {{ sitecore.betBuilderEntainUI.messages?.EditPickButton }}
    @if (!epcotEnabled) {
        <vn-icon slot="end" name="theme-edit" size="12" />
    }
</button>

<ng-template #header>
    <ms-betbuilder-overlay-header
        [eventName]="event.name"
        [eventStartDate]="event.startDate"
        [sportId]="event.sport.id"
        [leagueId]="event.league.id"
        [eventId]="event.id"
        [eventParticipants]="event.participants"
        [eventViewType]="event.viewType" />
</ng-template>
